import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const MessengerIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.4 0 27 15"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        clip-rule="evenodd"
        d="m.296875 7.75931c0-4.4576 3.493695-7.75931 7.999295-7.75931 4.50563 0 7.99933 3.30371 7.99933 7.76131 0 4.45759-3.4937 7.75929-7.99933 7.75929-.80993 0-1.58586-.108-2.3158-.3079-.14198-.038-.29397-.028-.42796.0319l-1.58786.7c-.41596.184-.88392-.112-.89792-.566l-.044-1.4238c-.004-.176-.08399-.34-.21398-.456-1.55586-1.3919-2.511775-3.4077-2.511775-5.73949zm5.545365-1.45786-2.34979 3.72765c-.22598.358.21398.7599.54995.504l2.52377-1.91586c.16999-.12999.40597-.12999.57795-.002l1.86983 1.40186c.56195.42 1.36185.274 1.73585-.31995l2.3518-3.72567c.224-.35797-.216-.76194-.552-.50596l-2.5237 1.91583c-.17002.12999-.406.12999-.57799.002l-1.86983-1.40188c-.56195-.41996-1.36188-.27397-1.73584.31998z"
        fill={color}
        fill-rule="evenodd"
      />
    </Svg>
  )
}

export default MessengerIconSvg
